<template>
  <div class="e2e-single-upload-container">
    <el-upload class="e2e-single-upload"
      ref="upload"
      :action="localAction"
      :data="params"
      :auto-upload="autoUpload"
      :before-upload="localBeforeUpload"
      :on-change='onChange'
      :on-success='onSuccess'
      :on-error='onError'
      :headers="headers"
      :limit="limit"
      :disabled="disabled"
      :on-exceed="onExceed"
      :accept="localAccept"
      :multiple="multiple"
      :show-file-list="false"
      :with-credentials="true">
      <slot></slot>
    </el-upload>
  </div>
</template>

<script>
import { E2E_FILE_TYPE_ENUM, E2E_INTL_HEADER, E2E_LANGUAGE_STORAGE_KEY, E2E_TOKEN_NAME } from '@/constant/common';
import { baseURL } from '@/util/axios';


export default {
  props: {
    action: {
      type: String, // 上传地址,自动上传时需要
      default: ''
    },
    multiple: {
      type: Boolean, // 是否允许多文件上传
      default: false
    },
    accept: {
      type: String, // 接受上传的文件类型 ex: .pdf,.png, 全部类型为 '*'
      //   required: true
      default: '*'
    },
    maxFileSize: {
      type: Number, // 最大上传文件大小，单位为 M
      default: 50
    },
    disabled: {
      type: Boolean, // 是否允许上传
      default: false
    },
    autoUpload: {
      type: Boolean, // 是否自动上传
      default: true
    },
    params: {},
    limit: { // 最大允许上传个数
      type: Number,
      default: 0
    },
    success: { // 成功的回调函数
      type: Function
      //   required: true
    },
    error: { // 失败的回调函数
      type: Function
    },
    change: { // change的回调函数
      type: Function
    },
    beforeUpload: {
      type: Function
    },
    showSuccessTip: { // 是否显示上传成功提示
      type: Boolean, // 是否自动上传
      default: true
    }
  },
  components: {},
  data() {
    return {
      baseURL: baseURL,
      headers: {
        [E2E_TOKEN_NAME]: localStorage.getItem(E2E_TOKEN_NAME),
        [E2E_INTL_HEADER]: localStorage.getItem(E2E_LANGUAGE_STORAGE_KEY)
      },
      loading: undefined
    };
  },
  computed: {
    localAccept: function () {
      const accept = [];
      if (this.accept === '*') {
        return '*';
      }
      let allowKeys = this.accept.split(',');
      allowKeys = allowKeys.map(x => {
        return x.trim();
      });
      for (const typeKey in E2E_FILE_TYPE_ENUM) {
        if (allowKeys.indexOf(typeKey) != -1) {
          E2E_FILE_TYPE_ENUM[typeKey].map((item, index) => {
            accept.push(`.${item}`);
          });
        }
      }
      if (accept.length == 0) {
        return '*';
      }
      return accept.join(',');
    },
    localAction: function () {
      let l_action = '';
      if (this.action) {
        if (this.action.substr(0, 1) == '/') {
          l_action = baseURL ? (baseURL + this.action) : this.action;
        } else {
          l_action = baseURL ? (baseURL + '/' + this.action) : ('/' + this.action);
        }
      }
      return l_action;
    }
  },
  watch: {},
  methods: {
    onExceed() {
      this.$message({
        type: 'error',
        message: this.$t('component.filebox.limit_prefix') + `${this.limit}` + this.$t('component.filebox.limit_suffix') + (this.limit.length > 1 ? this.$t('system.plural_suffix') : '')
      });
    },
    localBeforeUpload(file) {
      if (!this.checkFileFormat(file)) {
        return false;
      }
      let allowUpload = true;
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > this.maxFileSize) {
        this.$message({
          type: 'error',
          message: this.$t('component.singleupload.max_size_prefix') + `${this.maxFileSize}` + this.$t('component.singleupload.max_size_suffix')
        });
        return false;
      }
      if (this.beforeUpload) {
        allowUpload = this.beforeUpload(file);
      }
      if (allowUpload) {
        this.loading = this.$loading({
          lock: true,
          text: this.$t('component.singleupload.uploading')
        });
      }
      return allowUpload;
    },
    onChange(file, fileList) {
      const fileSize = file.size / 1024 / 1024;
      if (!this.checkFileFormat(file)) {
        return false;
      }
      if (fileSize > this.maxFileSize) {
        this.$message({
          type: 'error',
          message: this.$t('component.singleupload.max_size_prefix') + `${this.maxFileSize}` + this.$t('component.singleupload.max_size_suffix')
        });
        return false;
      }
      if (this.change) {
        this.change(file);
      }
    },
    checkFileFormat(file) {
      if (this.localAccept == '*') {
        return true;
      }
      const fileSuffix = this.$getFileSuffix(file.name).toLowerCase();
      if (this.localAccept.split(',').indexOf('.' + fileSuffix) == -1) {
        this.$message.error(this.$t('component.singleupload.error_file_format'));
        return false;
      }
      return true;
    },
    onSuccess(response, file, fileList) {
      if (response.code == 200) {
        if (this.showSuccessTip) {
          this.$message.success(this.$t('component.singleupload.upload_success'));
        }
        this.loading.close();
        const fileId = file.response.result[0];
        file.id = fileId;
        this.success(file, response);
        this.$refs.upload.clearFiles();
      } else {
        this.loading.close();
        this.success(file, response);
        this.$refs.upload.clearFiles();
      }

    },
    onError(err, file, fileList) {
      this.loading.close();
      this.$message.error(this.$t('component.singleupload.upload_failed'));
      if (this.error) {
        this.error(err, file);
      }
    }
  },
  mounted() {
    // console.log('single upload', this.params);
  }
};
</script>
<style lang='less' scoped>
.e2e-single-upload {
  height: 100%;
  display: flex;
  // display: inline-block;
  align-items: center;
}
.el-button {
  + .e2e-single-upload-container {
    margin: 0 0 0 8px;
  }
}
.e2e-single-upload-container {
  display: inline-block;
  + .el-button {
    margin: 0 0 0 8px;
  }
}
</style>



// WEBPACK FOOTER //
// SingleUpload.vue?6216f8d9